function install(id) {
  return new Promise((resolve, reject) => {
    let script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://widget.intercom.io/widget/${id}`

    script.addEventListener('load', () => resolve(window.Intercom))
    script.addEventListener('error', reject)

    document.head.appendChild(script)
  })
}

export default function (ctx) {
  const store = ctx.$store
  const { intercomAppId: app_id, user } = store.state

  const data = {
    app_id,
    api_base: 'https://api-iam.eu.intercom.io',
    created_at: Math.floor(new Date(user.createdAt).getTime() / 1000),
    user_hash: user.tokens.intercom,
    user_id: user.email,
    //show intercom button
    hide_default_launcher: false,
  }

  return install(data.app_id).then(Intercom => {
    // if (store.getters.isSuperadmin && process.env.NODE_ENV === 'production') return Intercom
    Intercom('boot', data)
    return Intercom
  })
}
